import React from 'react';
import { SVG } from './svg';

export const ArrowLeftIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M13.3334 22.6667L6.66669 16L13.3334 9.33332M26.6667 16L7.00003 16" />
  </SVG>
);

export const ArrowRightIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M18.6666 9.33334L25.3333 16L18.6666 22.6667M5.33331 16L25 16" />
  </SVG>
);

export const BestPracticesIcon = ({ color = 'black', ...props }: any) => (
  <SVG fill={color} stroke="transparent" {...props}>
    <path d="M15.9993 4L18.7984 8.30956L23.7128 6.80747L23.0869 11.908L27.817 13.9162L24.059 17.4211L26.3916 22L21.2599 22.2693L20.1036 27.2763L15.9993 24.184L11.8951 27.2763L10.7388 22.2693L5.60703 22L7.93967 17.4211L4.18164 13.9162L8.91178 11.908L8.28588 6.80747L13.2002 8.30956L15.9993 4Z" />
  </SVG>
);

export const BoldIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke="transparent" {...props}>
    <path
      d="M10 24H17.1994C20.9842 24 23 22.0078 23 19.3018C23 16.7866 21.2146 15.2676 19.2975 15.1763V15.0103C21.05 14.6118 22.3418 13.3584 22.3418 11.3579C22.3418 8.80957 20.4658 7 16.7468 7H10V24ZM13.5627 21.0615V16.5459H16.5494C18.2608 16.5459 19.3222 17.542 19.3222 18.9448C19.3222 20.2231 18.4582 21.0615 16.4671 21.0615H13.5627ZM13.5627 14.1138V9.90527H16.2696C17.8494 9.90527 18.7462 10.7271 18.7462 11.9556C18.7462 13.3003 17.6601 14.1138 16.2038 14.1138H13.5627Z"
      fill={color}
    />
  </SVG>
);

export const BulbIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path
      d="M10 12C10 8.13401 13.134 5 17 5C20.866 5 24 8.13401 24 12V12.4031C24 14.0842 23.4279 15.7151 22.3777 17.0278L21.2374 18.4533C20.4364 19.4545 20 20.6985 20 21.9807V24C20 25.6569 18.6569 27 17 27C15.3431 27 14 25.6569 14 24V21.9807C14 20.6985 13.5636 19.4545 12.7626 18.4533L11.6223 17.0278C10.5721 15.7151 10 14.0842 10 12.4031V12Z"
      strokeWidth="1.5"
    />
    <path d="M13.5 22.5L20.5 21M13.5 24.5L20.5 23M15 12.5H19" />
  </SVG>
);

export const BulletsIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke="transparent" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 11C7.32843 11 8 10.3284 8 9.5C8 8.67157 7.32843 8 6.5 8C5.67157 8 5 8.67157 5 9.5C5 10.3284 5.67157 11 6.5 11ZM6.5 24C7.32843 24 8 23.3284 8 22.5C8 21.6716 7.32843 21 6.5 21C5.67157 21 5 21.6716 5 22.5C5 23.3284 5.67157 24 6.5 24ZM8 16C8 16.8284 7.32843 17.5 6.5 17.5C5.67157 17.5 5 16.8284 5 16C5 15.1716 5.67157 14.5 6.5 14.5C7.32843 14.5 8 15.1716 8 16ZM11 8.5C10.4477 8.5 10 8.94772 10 9.5C10 10.0523 10.4477 10.5 11 10.5H26C26.5523 10.5 27 10.0523 27 9.5C27 8.94772 26.5523 8.5 26 8.5H11ZM10 22.5C10 21.9477 10.4477 21.5 11 21.5H26C26.5523 21.5 27 21.9477 27 22.5C27 23.0523 26.5523 23.5 26 23.5H11C10.4477 23.5 10 23.0523 10 22.5ZM11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H26C26.5523 17 27 16.5523 27 16C27 15.4477 26.5523 15 26 15H11Z"
      fill={color}
    />
  </SVG>
);

export const CameraIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M4.5 11.5H10.5L12.5 8.5H19.5L21.5 11.5H27.5V24.5H4.5V11.5Z" />
    <path d="M20.5 17C20.5 19.4853 18.4853 21.5 16 21.5C13.5147 21.5 11.5 19.4853 11.5 17C11.5 14.5147 13.5147 12.5 16 12.5C18.4853 12.5 20.5 14.5147 20.5 17Z" />
  </SVG>
);

export const CheckIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M8.83338 18L12.6667 21.8333L24.5 10" />
  </SVG>
);

export const ChevronDownIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M12 14L15.835 17.835L19.67 14" />
  </SVG>
);

export const ChevronLeftIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M18 12L14.165 15.835L18 19.67" />
  </SVG>
);

export const ChevronRightIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M14 20L17.835 16.165L14 12.33" />
  </SVG>
);

export const ChevronUpIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M20 18L16.165 14.165L12.33 18" />
  </SVG>
);

export const CompletenessIcon = ({ color = 'black', ...props }: any) => (
  <SVG fill={color} stroke="transparent" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 6H7V14H25V6ZM7 15H25V18H7V15ZM25 20H7V22H25V20ZM25 25H7V26H25V25Z"
    />
  </SVG>
);

export const ConferenceIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M16 8.5V3M16 8.5H14M16 8.5H18M8.5 6.5H23.5V27.5H8.5V6.5Z" />
  </SVG>
);

export const CopyIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M19.5 22V25.5H6.5V12.5H10M12.5 6.5H25.5V19.5H12.5V6.5Z" />
  </SVG>
);

export const CreditCardIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M4 12H28M28 15H4M6 24H26C27.1046 24 28 23.1046 28 22V10C28 8.89543 27.1046 8 26 8H6C4.89543 8 4 8.89543 4 10V22C4 23.1046 4.89543 24 6 24Z" />
  </SVG>
);

export const CrossIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M23 23L9 9M9 23L23 9" />
  </SVG>
);

export const DashboardIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M17.5 5.5H26.5V14.5H17.5V5.5Z" />
    <path d="M5.5 5.5H14.5V14.5H5.5V5.5Z" />
    <path d="M17.5 17.5H26.5V26.5H17.5V17.5Z" />
    <path d="M5.5 17.5H14.5V26.5H5.5V17.5Z" />
  </SVG>
);

export const DesignIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <circle cx="16" cy="11" r="6.5" />
    <path d="M23.5801 12.8708C26.689 14.6657 27.7542 18.6411 25.9593 21.75C24.1644 24.8589 20.189 25.924 17.0801 24.1291C13.9712 22.3342 12.906 18.3589 14.701 15.25C16.4959 12.1411 20.4712 11.0759 23.5801 12.8708Z" />
    <path d="M14.9199 24.1292C11.811 25.9241 7.83564 24.8589 6.04071 21.75C4.24579 18.6411 5.31098 14.6658 8.41988 12.8709C11.5288 11.076 15.5041 12.1411 17.299 15.25C19.094 18.3589 18.0288 22.3343 14.9199 24.1292Z" />
  </SVG>
);

export const DetailListSectionIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path
      d="M2 11.5H10M2 14.5H10M12 14.5L20 14.5M12 11.5L20 11.5M22 14.5H30M22 11.5H30M2 17.5H10M12 17.5L20 17.5M22 17.5H30M2 20.5H8M12 20.5H17M22 20.5H28"
      stroke="black"
    />
  </SVG>
);

export const DownloadIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M10.6667 14.6667L16 20.0001L21.3333 14.6667M16 5V19.5M25.5 23V26.4999H6.5L6.5 23" />
  </SVG>
);

export const Drag = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M14.6667 8H16M14.6667 13.3333H16M14.6667 18.6667H16M14.6667 24H16M10.6667 8H12M10.6667 13.3333H12M10.6667 18.6667H12M10.6667 24H12M18.6667 8H20M18.6667 13.3333H20M18.6667 18.6667H20M18.6667 24H20" />
  </SVG>
);

export const EditIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M6 25.5H26M21 6L23 8L8.5 22.5H6.5V20.5L21 6Z" />
  </SVG>
);

export const ExpandIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M24 13L27 16M27 16L24 19M27 16H19" stroke="white" />
    <path d="M13 8L16 5M16 5L19 8M16 5L16 13" stroke="white" />
    <path d="M8 13L5 16M5 16L8 19M5 16H13" stroke="white" />
    <path d="M13 24L16 27M16 27L19 24M16 27L16 19" stroke="white" />
  </SVG>
);

export const GiftIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path
      d="M16 8.5V24.5M16 8.5C16 6.5 18 5 20 5C22 5 22 6.5 22 7C22 7.5 21.5 8.5 20.5 8.5M16 8.5C16 6.5 14 5 12 5C10 5 10 6.5 10 7C10 7.5 10.5 8.5 11.5 8.5M7 12.5H25V24.5H7V12.5ZM6 8.5H26V12.5H6V8.5Z"
      stroke={color}
    />
  </SVG>
);

export const GroupedSkillsIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M23 6.5H5.5V23.5M7.5 8.5H24.5V25.5H7.5V8.5Z" />
    <path d="M14.2857 19.9091H17.7143M14.8571 15.0909H17.1429M16 23C15.0532 23 14.2857 22.2674 14.2857 21.3636V20.2622C14.2857 19.5628 14.0364 18.8843 13.5787 18.3382L12.927 17.5606C12.3269 16.8446 12 15.955 12 15.0381V14.8182C12 12.7095 13.7909 11 16 11C18.2091 11 20 12.7095 20 14.8182V15.0381C20 15.955 19.6731 16.8446 19.073 17.5606L18.4213 18.3382C17.9636 18.8843 17.7143 19.5628 17.7143 20.2622V21.3636C17.7143 22.2674 16.9468 23 16 23Z" />
  </SVG>
);

export const FacebookIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path
      d="M17.6813 26.9889H18.1813V26.4889V16.5431H20.5648H21.0145L21.062 16.0959L21.4441 12.4962L21.5028 11.9434H20.9469H18.1826L18.1862 10.6431V10.6417C18.1862 10.4081 18.1923 10.2366 18.2145 10.1014C18.2361 9.97015 18.2675 9.90945 18.2926 9.87746C18.3309 9.82872 18.4753 9.69982 19.1238 9.69982H20.9265H21.4265V9.19982V5.59973V5.09973H20.9265H18.0426C16.2329 5.09973 14.9013 5.5566 14.0336 6.50178C13.1737 7.43841 12.8593 8.75833 12.8593 10.2826V11.9438H11.2H10.7V12.4438V16.0435V16.5435H11.2H12.8593V26.4889V26.9889H13.3593H17.6813Z"
      stroke={color}
    />
  </SVG>
);

export const FaceHappyIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M21 19C19.7293 20.2342 17.9586 21 16 21C14.0414 21 12.2707 20.2342 11 19M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" />
    <path d="M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z" />
    <path d="M20 15C20.5523 15 21 14.5523 21 14C21 13.4477 20.5523 13 20 13C19.4477 13 19 13.4477 19 14C19 14.5523 19.4477 15 20 15Z" />
  </SVG>
);

export const FaceNeutralIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M9 19H23M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" />
    <path d="M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z" />
    <path d="M20 15C20.5523 15 21 14.5523 21 14C21 13.4477 20.5523 13 20 13C19.4477 13 19 13.4477 19 14C19 14.5523 19.4477 15 20 15Z" />
  </SVG>
);

export const FaceSadIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M11 21C12.2707 19.7658 14.0414 19 16 19C17.9586 19 19.7293 19.7658 21 21M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" />
    <path d="M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z" />
    <path d="M20 15C20.5523 15 21 14.5523 21 14C21 13.4477 20.5523 13 20 13C19.4477 13 19 13.4477 19 14C19 14.5523 19.4477 15 20 15Z" />
  </SVG>
);

export const FaceVeryHappyIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M9.07025 19C10.4535 21.3912 13.0389 23 16 23C18.9611 23 21.5465 21.3912 22.9297 19M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" />
    <path d="M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z" />
    <path d="M20 15C20.5523 15 21 14.5523 21 14C21 13.4477 20.5523 13 20 13C19.4477 13 19 13.4477 19 14C19 14.5523 19.4477 15 20 15Z" />
  </SVG>
);

export const FaceVerySadIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M22.8595 22C21.4762 19.6088 18.8909 18 15.9297 18C12.9686 18 10.3832 19.6088 9 22M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" />
    <path d="M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z" />
    <path d="M20 15C20.5523 15 21 14.5523 21 14C21 13.4477 20.5523 13 20 13C19.4477 13 19 13.4477 19 14C19 14.5523 19.4477 15 20 15Z" />
  </SVG>
);

export const FormattingIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M7 20V25H12" strokeWidth="3" />
    <path d="M25 12L25 7L20 7" strokeWidth="3" />
    <path d="M12 7L7 7L7 12" strokeWidth="3" />
    <path d="M20 25L25 25L25 20" strokeWidth="3" />
  </SVG>
);

export const GraduationIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M24.5 14.5V20L16.3036 24L7.5 20V14.5M22 15.5V26.5M2.5 12L15.5179 6L29.5 12L16.4821 18L2.5 12Z" />
  </SVG>
);

export const HandIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M24 20.5C24 24.6421 20.6421 28 16.5 28C12.3579 28 9 24.6421 9 20.5M12 10.5C12 9.67157 11.3284 9 10.5 9C9.67157 9 9 9.67157 9 10.5V21M15 6.5C15 5.67157 14.3284 5 13.5 5C12.6716 5 12 5.67157 12 6.5V16M15 16V5.5C15 4.67157 15.6716 4 16.5 4C17.3284 4 18 4.67157 18 5.5V16M21 15.5V6.5C21 5.67157 20.3284 5 19.5 5C18.6716 5 18 5.67157 18 6.5M21 15.5V18.5M21 15.5C21 14.6716 21.6716 14 22.5 14C23.3284 14 24 14.6716 24 15.5V21" />
  </SVG>
);

export const HeartIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M7.50758 16.6448C5.49747 14.6672 5.49748 11.4608 7.50758 9.48321C9.51768 7.5056 12.7767 7.5056 14.7868 9.48321L16 10.6768L17.2132 9.48322C19.2233 7.5056 22.4823 7.5056 24.4924 9.48321C26.5025 11.4608 26.5025 14.6672 24.4924 16.6448L16 25L7.50758 16.6448Z" />
  </SVG>
);

export const ImpactIcon = ({ color = 'black', ...props }: any) => (
  <SVG fill={color} stroke="transparent" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26ZM16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28ZM16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21ZM16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23ZM16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
    />
  </SVG>
);

export const InfoIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M14 14H16V20M16 20H13.5M16 20H18.5M16 10V12M26 16C26 21.5228 21.5228 26 16 26C10.4772 26 6 21.5228 6 16C6 10.4772 10.4772 6 16 6C21.5228 6 26 10.4772 26 16Z" />
  </SVG>
);

export const ImportIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M13.5 13L13.5 6.5L25.5 6.5L25.5 25.5L13.5 25.5L13.5 18M4 15.5L20.5 15.5M17 19.5L21 15.5L17 11.5" />
  </SVG>
);

export const ItalicIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke="transparent" {...props}>
    <path
      d="M10 24L10.2605 22.3926H14.4044L16.6539 8.60745H12.51L12.7705 7H23L22.7395 8.60745H18.5956L16.3461 22.3926H20.49L20.2295 24H10Z"
      fill={color}
    />
  </SVG>
);

export const LanguageIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M7 11.2778H16M25 11.2778H16M16 6V11.2778M21.625 11.2778C21.25 14.4444 18.475 21.6222 10.375 25M21.625 25C15.2485 22.3409 12.172 17.3269 10.9685 13.7687" />
  </SVG>
);

export const LinkedinIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M9.60817 12.7025H5.25703V25.7759H9.60817V12.7025Z" />
    <path d="M9.89501 8.65855C9.86677 7.37671 8.95012 6.40039 7.46163 6.40039C5.97313 6.40039 5 7.37671 5 8.65855C5 9.91383 5.97217 10.9183 7.43295 10.9183C8.95012 10.9183 9.89501 9.91383 9.89501 8.65855Z" />
    <path d="M26.3002 18.281C26.3002 14.2654 24.1537 12.3965 21.2904 12.3965C18.9802 12.3965 17.9459 13.6654 17.3684 14.5556V12.7038H13.0168C13.0741 13.9306 13.0168 25.7772 13.0168 25.7772H17.3684V18.4759C17.3684 18.0852 17.3967 17.6955 17.5117 17.4157C17.8262 16.6351 18.5422 15.827 19.7443 15.827C21.3194 15.827 21.9491 17.0258 21.9491 18.7826V25.7768H26.3L26.3002 18.281Z" />
  </SVG>
);

export const ListIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M11 8.5L26 8.5M6 8.5H8M11 13.5L26 13.5M6.00002 13.5H8.00002M11 18.5L26 18.5M6.00002 18.5H8.00002M11 23.5L26 23.5M6 23.5H8" />
  </SVG>
);

export const LockIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M20.5 15.5V13.5C20.5 12.5476 20.4992 11.4084 20.4654 10.9135C20.4326 10.432 20.3736 10.1976 20.3097 10.0433C20.056 9.43072 19.5693 8.94404 18.9567 8.6903C18.8024 8.62639 18.568 8.56743 18.0865 8.53458C17.5916 8.50081 16.9524 8.5 16 8.5C15.0476 8.5 14.4084 8.50081 13.9135 8.53458C13.432 8.56743 13.1976 8.62639 13.0433 8.6903C12.4307 8.94404 11.944 9.43072 11.6903 10.0433C11.6264 10.1976 11.5674 10.432 11.5346 10.9135C11.5008 11.4084 11.5 12.5476 11.5 13.5V15.5M23.5 15.5V13.4495C23.5 12.5606 23.5 11.3185 23.4585 10.7093C23.4152 10.0751 23.3219 9.47602 23.0813 8.89524C22.5231 7.54759 21.4524 6.47688 20.1048 5.91866C19.524 5.6781 18.9249 5.58481 18.2907 5.54154C17.6815 5.49997 16.9394 5.49999 16.0505 5.5H15.9495C15.0606 5.49999 14.3185 5.49997 13.7093 5.54154C13.0751 5.58481 12.476 5.6781 11.8952 5.91866C10.5476 6.47688 9.47688 7.54759 8.91866 8.89524C8.6781 9.47602 8.58481 10.0751 8.54154 10.7093C8.49997 11.3185 8.49999 12.5606 8.5 13.4495V15.5M16 18.5V22M6.5 15.5H25.5V25.5H6.5V15.5Z" />
  </SVG>
);

export const LogoutIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M18.5 13L18.5 6.5L6.5 6.5L6.5 25.5L18.5 25.5L18.5 18M28 15.5L11.5 15.5M15 19.5L11 15.5L15 11.5" />
  </SVG>
);

export const MenuIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M5 8.5L27 8.5M5 15.5H27M5 22.5H27" />
  </SVG>
);

export const MoreIcon = ({ color = 'black', ...props }: any) => (
  <SVG fill={color} stroke="none" {...props}>
    <path d="M10 16C10 17.1046 9.10457 18 8 18C6.89543 18 6 17.1046 6 16C6 14.8954 6.89543 14 8 14C9.10457 14 10 14.8954 10 16Z" />
    <path d="M18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16Z" />
    <path d="M24 18C25.1046 18 26 17.1046 26 16C26 14.8954 25.1046 14 24 14C22.8954 14 22 14.8954 22 16C22 17.1046 22.8954 18 24 18Z" />
  </SVG>
);

export const PatentsIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path
      d="M16 5.8785L17.2885 7.73997L17.5639 8.1378L17.9705 7.87564L19.8733 6.64896L20.3514 8.86182L20.4536 9.33475L20.9296 9.24817L23.157 8.84302L22.7518 11.0704L22.6652 11.5464L23.1382 11.6486L25.351 12.1267L24.1244 14.0295L23.8622 14.4361L24.26 14.7115L26.1215 16L24.26 17.2885L23.8622 17.5639L24.1244 17.9705L25.351 19.8733L23.1382 20.3514L22.6652 20.4536L22.7518 20.9296L23.157 23.157L20.9296 22.7518L20.4536 22.6652L20.3514 23.1382L19.8733 25.351L17.9705 24.1244L17.5639 23.8622L17.2885 24.26L16 26.1215L14.7115 24.26L14.4361 23.8622L14.0295 24.1244L12.1267 25.351L11.6486 23.1382L11.5464 22.6652L11.0704 22.7518L8.84302 23.157L9.24817 20.9296L9.33475 20.4536L8.86182 20.3514L6.64896 19.8733L7.87564 17.9705L8.1378 17.5639L7.73997 17.2885L5.8785 16L7.73997 14.7115L8.1378 14.4361L7.87564 14.0295L6.64896 12.1267L8.86182 11.6486L9.33475 11.5464L9.24817 11.0704L8.84302 8.84302L11.0704 9.24817L11.5464 9.33475L11.6486 8.86182L12.1267 6.64896L14.0295 7.87564L14.4361 8.1378L14.7115 7.73997L16 5.8785Z"
      stroke="black"
    />
  </SVG>
);

export const PlusIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M7 16H25M16 25V7" />
  </SVG>
);

export const ProjectsIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M4 20.3333V8.66667C4 7.00982 5.34315 5.66667 7 5.66667C7.76835 5.66667 8.46924 5.95553 9 6.43057V18.0972C8.46924 17.6222 7.76835 17.3333 7 17.3333C5.34315 17.3333 4 18.6765 4 20.3333ZM4 20.3333C4 21.9902 5.34315 23.3333 7 23.3333H27.3333V8.66667H9M12 12.6667H13.3333M15.3333 12.6667H24M12 15.3333H13.3333M15.3333 15.3333H24M12 18H13.3333M15.3333 18H22" />
  </SVG>
);

export const ReferencesIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M13 15L15 17L20 12M6 5.5H26M4.5 7.5H27.5V21.5H9.5L4.5 26.5V7.5Z" />
  </SVG>
);

export const StandardSectionIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M4 8.5H28M4 11.5H28M4 14.5H24M7 17.5H28M4.00001 17.5H5.33334M7 20.5H28M4.00001 20.5H5.33334M4.00001 23.5H5.33334M7 23.5H24" />
  </SVG>
);

export const SuitcaseIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M19.5 10.5V6.5H12.5V10.5M4.5 15.5V25.5H27.5V15.5M4.5 15.5V10.5H27.5V15.5M4.5 15.5H27.5M21.5 14V17M10.5 14V17" />
  </SVG>
);

export const TagListSectionIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M13.5 9.5H4.5L4.50002 12.5H13.5L13.5 9.5Z" />
    <path d="M9.5 14.5H4.50002V17.5H9.5V14.5Z" />
    <path d="M27.5 14.5H21.5V17.5H27.5V14.5Z" />
    <path d="M22.5 9.5H15.5L15.5 12.5H22.5L22.5 9.5Z" />
    <path d="M19.5 14.5H11.5V17.5H19.5V14.5Z" />
    <path d="M13.5 19.5H4.50002V22.5H13.5V19.5Z" />
  </SVG>
);

export const TrashIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M7.50004 7.5L7.50004 27.5H24.5V7.5M7.50004 7.5H5M7.50004 7.5H12.5M24.5 7.5H19.5M24.5 7.5H27M12.5 7.5L12.5 4.5L19.5 4.5L19.5 7.5M12.5 7.5H19.5M12.5 12V23M19.5 23V12" />
  </SVG>
);

export const TwitterIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path
      d="M16.1111 12.4691L16.1545 13.1957L15.4319 13.1067C12.8018 12.7657 10.5041 11.6089 8.55321 9.66628L7.59944 8.70236L7.35377 9.41418C6.83353 11.0009 7.1659 12.6767 8.24974 13.8037C8.82778 14.4266 8.69772 14.5155 7.7006 14.1448C7.35377 14.0262 7.0503 13.9372 7.02139 13.9817C6.92024 14.0855 7.26706 15.435 7.54163 15.9688C7.91736 16.7103 8.68327 17.437 9.52143 17.867L10.2295 18.2081L9.39137 18.2229C8.58211 18.2229 8.55321 18.2378 8.63992 18.5492C8.92894 19.5131 10.0706 20.5363 11.3423 20.9812L12.2382 21.2926L11.4579 21.7672C10.3018 22.4493 8.94339 22.8349 7.58499 22.8646C6.93469 22.8794 6.4 22.9387 6.4 22.9832C6.4 23.1315 8.16303 23.962 9.18906 24.2882C12.2671 25.2521 15.9233 24.8369 18.669 23.1908C20.6199 22.0193 22.5708 19.691 23.4812 17.437C23.9725 16.2358 24.4639 14.041 24.4639 12.9881C24.4639 12.3059 24.5072 12.217 25.3165 11.4013C25.7934 10.9268 26.2414 10.4078 26.3281 10.2595C26.4726 9.9777 26.4581 9.9777 25.7211 10.2298C24.4928 10.6747 24.3194 10.6154 24.9263 9.94804C25.3743 9.4735 25.909 8.61338 25.909 8.36128C25.909 8.31679 25.6922 8.39094 25.4466 8.52441C25.1864 8.6727 24.6084 8.89514 24.1749 9.02861L23.3945 9.28071L22.6864 8.79134C22.2962 8.52441 21.7471 8.22782 21.458 8.13884C20.721 7.93122 19.5939 7.96088 18.9291 8.19816C17.1227 8.86549 15.9811 10.5857 16.1111 12.4691Z"
      stroke={color}
    />
  </SVG>
);

export const QuestionMarkIcon = ({ color = 'black', ...props }: any) => (
  <SVG stroke={color} {...props}>
    <path d="M12.265 11.8416C12.265 9.92082 13.5455 8 16.1066 8C18.6677 8 20.1451 9.58725 20.1451 11.5941C20.1451 13.8975 18.8071 14.3679 18.047 15.0378C16.6298 16.2869 15.8348 16.5201 15.8348 19.8451" />
    <ellipse cx="15.8919" cy="23.4684" rx="0.281946" ry="0.281946" />
  </SVG>
);

export const LinkIcon = ({ color = 'black', ...props }: any) => (
  <SVG fill={color} stroke="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9023 14.0777C28.1033 11.8768 28.1033 8.30833 25.9023 6.10738C23.7014 3.90643 20.133 3.90643 17.932 6.10738L13.9983 10.0411C13.6078 10.4316 13.6078 11.0647 13.9983 11.4553C14.3888 11.8458 15.022 11.8458 15.4125 11.4553L19.3462 7.52159C20.7661 6.10169 23.0682 6.10169 24.4881 7.52159C25.908 8.94149 25.908 11.2436 24.4881 12.6635L20.5545 16.5972C19.1346 18.0171 16.8324 18.0171 15.4125 16.5972C15.2462 16.4309 15.0999 16.2532 14.9733 16.0669C14.6627 15.6102 14.0407 15.4918 13.584 15.8023C13.1273 16.1129 13.0089 16.7348 13.3194 17.1915C13.5163 17.4811 13.7428 17.7558 13.9983 18.0114C16.1993 20.2124 19.7677 20.2124 21.9687 18.0114L25.9023 14.0777ZM6.11714 17.9222C3.91619 20.1231 3.91619 23.6916 6.11714 25.8925C8.31809 28.0935 11.8865 28.0935 14.0875 25.8925L18.0212 21.9589C18.4117 21.5683 18.4117 20.9352 18.0212 20.5446C17.6306 20.1541 16.9975 20.1541 16.607 20.5446L12.6733 24.4783C11.2534 25.8982 8.95126 25.8982 7.53136 24.4783C6.11146 23.0584 6.11146 20.7563 7.53136 19.3364L11.465 15.4027C12.8849 13.9828 15.1871 13.9828 16.607 15.4027C16.7733 15.569 16.9196 15.7467 17.0462 15.933C17.3568 16.3897 17.9787 16.5082 18.4354 16.1976C18.8921 15.8871 19.0106 15.2651 18.7001 14.8084C18.5032 14.5188 18.2767 14.2441 18.0212 13.9885C15.8202 11.7876 12.2518 11.7876 10.0508 13.9885L6.11714 17.9222Z"
    />
  </SVG>
);

export const SettingsIcon = ({ color = 'black', ...props }: any) => (
  <SVG fill={color} stroke="none" {...props}>
    <mask id="path-1-inside-1_8153_18477" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.91487 6.3139L11.7163 8.08284C12.2569 7.78977 12.8308 7.55044 13.4309 7.37201L14.161 4.14003C14.7606 4.04783 15.3747 4 16 4C16.6253 4 17.2394 4.04783 17.839 4.14003L18.5691 7.37201C19.1692 7.55044 19.7431 7.78977 20.2837 8.08284L23.0851 6.3139C24.0795 7.04249 24.9575 7.9205 25.6861 8.91487L23.9172 11.7164C24.2102 12.2569 24.4496 12.8308 24.628 13.4309L27.86 14.161C27.9522 14.7606 28 15.3747 28 16C28 16.6253 27.9522 17.2394 27.86 17.839L24.628 18.5691C24.4496 19.1692 24.2102 19.7431 23.9172 20.2836L25.6861 23.0851C24.9575 24.0795 24.0795 24.9575 23.0851 25.6861L20.2836 23.9172C19.7431 24.2102 19.1692 24.4496 18.5691 24.628L17.839 27.86C17.2394 27.9522 16.6253 28 16 28C15.3747 28 14.7606 27.9522 14.161 27.86L13.4309 24.628C12.8308 24.4496 12.2569 24.2102 11.7163 23.9172L8.91487 25.6861C7.9205 24.9575 7.04249 24.0795 6.3139 23.0851L8.08284 20.2837C7.78977 19.7431 7.55044 19.1692 7.37201 18.5691L4.14003 17.839C4.04783 17.2394 4 16.6253 4 16C4 15.3747 4.04783 14.7606 4.14003 14.161L7.37201 13.4309C7.55044 12.8308 7.78977 12.2569 8.08284 11.7163L6.3139 8.91487C7.04249 7.9205 7.9205 7.04249 8.91487 6.3139ZM16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
      />
    </mask>
    <path
      d="M11.7163 8.08284L11.1824 8.92839L11.6779 9.24123L12.193 8.96194L11.7163 8.08284ZM8.91487 6.3139L9.44878 5.46835L8.87306 5.10483L8.32383 5.50726L8.91487 6.3139ZM13.4309 7.37201L13.7159 8.33054L14.2772 8.16364L14.4063 7.59237L13.4309 7.37201ZM14.161 4.14003L14.009 3.15165L13.3357 3.25519L13.1856 3.91966L14.161 4.14003ZM17.839 4.14003L18.8144 3.91966L18.6643 3.25519L17.991 3.15165L17.839 4.14003ZM18.5691 7.37201L17.5937 7.59238L17.7228 8.16364L18.2841 8.33054L18.5691 7.37201ZM20.2837 8.08284L19.807 8.96194L20.3221 9.24123L20.8176 8.92839L20.2837 8.08284ZM23.0851 6.3139L23.6762 5.50726L23.1269 5.10483L22.5512 5.46835L23.0851 6.3139ZM25.6861 8.91487L26.5316 9.44878L26.8952 8.87306L26.4927 8.32384L25.6861 8.91487ZM23.9172 11.7164L23.0716 11.1824L22.7588 11.6779L23.0381 12.193L23.9172 11.7164ZM24.628 13.4309L23.6695 13.7159L23.8364 14.2772L24.4076 14.4063L24.628 13.4309ZM27.86 14.161L28.8484 14.009L28.7448 13.3357L28.0803 13.1856L27.86 14.161ZM27.86 17.839L28.0803 18.8144L28.7448 18.6643L28.8484 17.991L27.86 17.839ZM24.628 18.5691L24.4076 17.5937L23.8364 17.7228L23.6695 18.2841L24.628 18.5691ZM23.9172 20.2836L23.0381 19.807L22.7588 20.3221L23.0716 20.8176L23.9172 20.2836ZM25.6861 23.0851L26.4927 23.6762L26.8952 23.1269L26.5316 22.5512L25.6861 23.0851ZM23.0851 25.6861L22.5512 26.5316L23.1269 26.8952L23.6762 26.4927L23.0851 25.6861ZM20.2836 23.9172L20.8176 23.0716L20.3221 22.7588L19.807 23.0381L20.2836 23.9172ZM18.5691 24.628L18.2841 23.6695L17.7228 23.8364L17.5937 24.4076L18.5691 24.628ZM17.839 27.86L17.991 28.8484L18.6643 28.7448L18.8144 28.0803L17.839 27.86ZM14.161 27.86L13.1856 28.0803L13.3357 28.7448L14.009 28.8484L14.161 27.86ZM13.4309 24.628L14.4063 24.4076L14.2772 23.8364L13.7159 23.6695L13.4309 24.628ZM11.7163 23.9172L12.193 23.0381L11.6779 22.7588L11.1824 23.0716L11.7163 23.9172ZM8.91487 25.6861L8.32384 26.4927L8.87306 26.8952L9.44878 26.5316L8.91487 25.6861ZM6.3139 23.0851L5.46835 22.5512L5.10483 23.1269L5.50726 23.6762L6.3139 23.0851ZM8.08284 20.2837L8.92838 20.8176L9.24123 20.3221L8.96193 19.807L8.08284 20.2837ZM7.37201 18.5691L8.33054 18.2841L8.16363 17.7228L7.59237 17.5937L7.37201 18.5691ZM4.14003 17.839L3.15165 17.991L3.25519 18.6643L3.91966 18.8144L4.14003 17.839ZM4.14003 14.161L3.91966 13.1856L3.25519 13.3357L3.15165 14.009L4.14003 14.161ZM7.37201 13.4309L7.59237 14.4063L8.16363 14.2772L8.33054 13.7159L7.37201 13.4309ZM8.08284 11.7163L8.96193 12.193L9.24123 11.6779L8.92838 11.1824L8.08284 11.7163ZM6.3139 8.91487L5.50726 8.32383L5.10483 8.87306L5.46835 9.44878L6.3139 8.91487ZM12.2502 7.2373L9.44878 5.46835L8.38097 7.15944L11.1824 8.92839L12.2502 7.2373ZM13.1459 6.41348C12.4785 6.61191 11.8404 6.87802 11.2397 7.20375L12.193 8.96194C12.6733 8.70152 13.183 8.48897 13.7159 8.33054L13.1459 6.41348ZM13.1856 3.91966L12.4555 7.15165L14.4063 7.59237L15.1365 4.36039L13.1856 3.91966ZM16 3C15.3236 3 14.6587 3.05174 14.009 3.15165L14.313 5.12841C14.8624 5.04392 15.4258 5 16 5V3ZM17.991 3.15165C17.3413 3.05174 16.6764 3 16 3V5C16.5742 5 17.1376 5.04392 17.687 5.12841L17.991 3.15165ZM19.5445 7.15165L18.8144 3.91966L16.8635 4.36039L17.5937 7.59238L19.5445 7.15165ZM20.7603 7.20375C20.1596 6.87803 19.5215 6.61191 18.8541 6.41348L18.2841 8.33054C18.817 8.48897 19.3267 8.70152 19.807 8.96194L20.7603 7.20375ZM22.5512 5.46835L19.7497 7.2373L20.8176 8.92839L23.619 7.15944L22.5512 5.46835ZM26.4927 8.32384C25.7037 7.247 24.753 6.29627 23.6762 5.50726L22.4941 7.12054C23.406 7.78871 24.2113 8.59401 24.8795 9.50591L26.4927 8.32384ZM24.7627 12.2503L26.5316 9.44878L24.8406 8.38097L23.0716 11.1824L24.7627 12.2503ZM25.5865 13.1459C25.3881 12.4785 25.122 11.8404 24.7962 11.2397L23.0381 12.193C23.2985 12.6733 23.511 13.183 23.6695 13.7159L25.5865 13.1459ZM28.0803 13.1856L24.8483 12.4555L24.4076 14.4063L27.6396 15.1365L28.0803 13.1856ZM29 16C29 15.3236 28.9483 14.6587 28.8484 14.009L26.8716 14.313C26.9561 14.8624 27 15.4258 27 16H29ZM28.8484 17.991C28.9483 17.3413 29 16.6764 29 16H27C27 16.5742 26.9561 17.1376 26.8716 17.687L28.8484 17.991ZM24.8483 19.5445L28.0803 18.8144L27.6396 16.8635L24.4076 17.5937L24.8483 19.5445ZM24.7962 20.7603C25.122 20.1596 25.3881 19.5215 25.5865 18.8541L23.6695 18.2841C23.511 18.817 23.2985 19.3267 23.0381 19.807L24.7962 20.7603ZM26.5316 22.5512L24.7627 19.7497L23.0716 20.8176L24.8406 23.619L26.5316 22.5512ZM23.6762 26.4927C24.753 25.7037 25.7037 24.753 26.4927 23.6762L24.8795 22.4941C24.2113 23.406 23.406 24.2113 22.4941 24.8795L23.6762 26.4927ZM19.7497 24.7627L22.5512 26.5316L23.619 24.8406L20.8176 23.0716L19.7497 24.7627ZM18.8541 25.5865C19.5215 25.3881 20.1596 25.122 20.7603 24.7963L19.807 23.0381C19.3267 23.2985 18.817 23.511 18.2841 23.6695L18.8541 25.5865ZM18.8144 28.0803L19.5445 24.8483L17.5937 24.4076L16.8635 27.6396L18.8144 28.0803ZM16 29C16.6764 29 17.3413 28.9483 17.991 28.8484L17.687 26.8716C17.1376 26.9561 16.5742 27 16 27V29ZM14.009 28.8484C14.6587 28.9483 15.3236 29 16 29V27C15.4258 27 14.8624 26.9561 14.313 26.8716L14.009 28.8484ZM12.4555 24.8484L13.1856 28.0803L15.1365 27.6396L14.4063 24.4076L12.4555 24.8484ZM11.2397 24.7963C11.8404 25.122 12.4785 25.3881 13.1459 25.5865L13.7159 23.6695C13.183 23.511 12.6733 23.2985 12.193 23.0381L11.2397 24.7963ZM9.44878 26.5316L12.2502 24.7627L11.1824 23.0716L8.38097 24.8406L9.44878 26.5316ZM5.50726 23.6762C6.29627 24.753 7.247 25.7037 8.32384 26.4927L9.50591 24.8795C8.59401 24.2113 7.78871 23.406 7.12054 22.4941L5.50726 23.6762ZM7.2373 19.7498L5.46835 22.5512L7.15944 23.619L8.92838 20.8176L7.2373 19.7498ZM6.41348 18.8541C6.61191 19.5215 6.87802 20.1596 7.20374 20.7603L8.96193 19.807C8.70151 19.3267 8.48897 18.817 8.33054 18.2841L6.41348 18.8541ZM3.91966 18.8144L7.15165 19.5445L7.59237 17.5937L4.36039 16.8635L3.91966 18.8144ZM3 16C3 16.6764 3.05174 17.3413 3.15165 17.991L5.12841 17.687C5.04392 17.1376 5 16.5742 5 16H3ZM3.15165 14.009C3.05174 14.6587 3 15.3236 3 16H5C5 15.4258 5.04392 14.8624 5.12841 14.313L3.15165 14.009ZM7.15165 12.4555L3.91966 13.1856L4.36039 15.1365L7.59237 14.4063L7.15165 12.4555ZM7.20375 11.2397C6.87802 11.8404 6.61191 12.4785 6.41348 13.1459L8.33054 13.7159C8.48897 13.183 8.70151 12.6733 8.96193 12.193L7.20375 11.2397ZM5.46835 9.44878L7.2373 12.2502L8.92838 11.1824L7.15944 8.38097L5.46835 9.44878ZM8.32383 5.50726C7.247 6.29627 6.29627 7.247 5.50726 8.32383L7.12054 9.50591C7.78871 8.59401 8.59401 7.78871 9.50591 7.12054L8.32383 5.50726ZM17 16C17 16.5523 16.5523 17 16 17V19C17.6569 19 19 17.6569 19 16H17ZM16 15C16.5523 15 17 15.4477 17 16H19C19 14.3431 17.6569 13 16 13V15ZM15 16C15 15.4477 15.4477 15 16 15V13C14.3431 13 13 14.3431 13 16H15ZM16 17C15.4477 17 15 16.5523 15 16H13C13 17.6569 14.3431 19 16 19V17Z"
      mask="url(#path-1-inside-1_8153_18477)"
    />
  </SVG>
);
